import { render, staticRenderFns } from "./UjianStart.vue?vue&type=template&id=216911ac&scoped=true"
import script from "./UjianStart.vue?vue&type=script&lang=js"
export * from "./UjianStart.vue?vue&type=script&lang=js"
import style0 from "./UjianStart.vue?vue&type=style&index=0&id=216911ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216911ac",
  null
  
)

export default component.exports